const cookiesBarSelector = '.cookies-bar';
const cookiesBarActiveClass = 'cookies-bar_active';

const cookiesBarButtonSelector = '.cookies-bar__button';

const elements = {};


const CookiesBar = () => {
  elements.cookiesBar = document.querySelector(cookiesBarSelector);
  elements.cookiesBarButton = document.querySelector(cookiesBarButtonSelector);

  if(!elements.cookiesBar) {
    return;
  }

  if(document.cookie.indexOf('cookies_accept=') === -1) {
    setTimeout(() => {
      elements.cookiesBar.classList.add(cookiesBarActiveClass);
    }, 1000);

    elements.cookiesBarButton.addEventListener('click', e => {
      e.preventDefault();

      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + 8 * 24 * 60 * 60 * 1000);

      document.cookie =  'cookies_accept=true; expires=' + expiryDate.toGMTString();
      elements.cookiesBar.classList.remove(cookiesBarActiveClass);
    });
  }
}

export default CookiesBar;
